import { getErrorPageContent } from './getErrorPageContent';

export const getErrorPage = async () => {
  const errorPage = getErrorPageContent();

  return {
    updates: [
      {
        type: 'initLayout',
        data: errorPage,
      },
    ],
  };
};
